import { format, parseISO } from "date-fns";
import { es } from "date-fns/locale";
import { billingDay } from "@/lib/billing-day";

export const CARD_GRACE_DEFAULT_DAYS = 7;
export const CARD_GRACE_MAX_DAYS = 60;

export interface CardAuthorizationStatus {
  awaitsAuthorization: boolean;
  graceUntil: string | null;
  graceLastDay: string | null;
  aiPaused: boolean;
}

export interface CardAuthorizationGraceRequest {
  lastDay: string | null;
  reason: string | null;
}

export function parseCardAuthorizationStatus(raw: unknown): CardAuthorizationStatus | null {
  if (!raw || typeof raw !== "object" || Array.isArray(raw)) return null;
  const item = raw as Record<string, unknown>;
  if (typeof item.awaits_authorization !== "boolean" || typeof item.ai_paused !== "boolean") return null;
  const graceUntil = typeof item.grace_until === "string" ? item.grace_until : null;
  const graceLastDay = typeof item.grace_last_day === "string" ? billingDay(item.grace_last_day.slice(0, 10)) : null;
  return {
    awaitsAuthorization: item.awaits_authorization,
    graceUntil,
    graceLastDay: graceUntil ? graceLastDay : null,
    aiPaused: item.ai_paused,
  };
}

export function graceIsRunning(status: CardAuthorizationStatus | null, now: Date = new Date()): boolean {
  if (!status?.graceUntil) return false;
  const until = new Date(status.graceUntil).getTime();
  return !Number.isNaN(until) && until > now.getTime();
}

export function showsCardGraceControl(status: CardAuthorizationStatus | null): boolean {
  return !!status && (status.awaitsAuthorization || status.graceUntil !== null);
}

export function addBillingDays(dayIso: string, days: number): string {
  const date = new Date(`${dayIso}T12:00:00Z`);
  date.setUTCDate(date.getUTCDate() + days);
  return date.toISOString().slice(0, 10);
}

export function formatGraceDay(dayIso: string): string {
  return format(parseISO(dayIso), "d 'de' MMMM 'de' yyyy", { locale: es });
}

export function formatGraceDayShort(dayIso: string): string {
  return format(parseISO(dayIso), "d 'de' MMMM", { locale: es });
}

export function cardGraceNotice(lastDay: string): string {
  return `Tu IA seguirá respondiendo hasta el ${formatGraceDayShort(lastDay)}; asocia tu tarjeta antes.`;
}
